import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { UserRole } from "../types/AppModel";

export const AuthRoute: React.FC = () => {
  const { cognitoUser, user } = useAuth();

  if (cognitoUser && user) {
    // Redirect authenticated users based on roles
    const userRole = cognitoUser.getSignInUserSession()?.getIdToken()?.payload[
      "custom:role"
    ];
    switch (userRole) {
      case UserRole.STUDENT:
        return <Navigate to="/student" replace />;
      case UserRole.TEACHER:
        return <Navigate to="/teacher" replace />;
      case UserRole.ADMIN:
        return <Navigate to="/admin" replace />;
      default:
        return <Navigate to="/auth/sign-in" replace />;
    }
  }

  return <Outlet />;
};
